// src/components/Page/News/Components.js
import Section from './Section';
import Title from './Title';
import Line from './Line';
import Link from './Link';

export { Section, Title, Line, Link };